var map = {
	"./Africa.png": "f1f7",
	"./Group.png": "f0b9",
	"./icons8_cards.png": "fdda",
	"./icons8_collaboration.png": "c8ce",
	"./icons8_customer_2.png": "ce26",
	"./icons8_delete_link.png": "d9bc",
	"./icons8_locker.png": "a79dc",
	"./icons8_metamorphose.png": "9f42",
	"./icons8_musically.png": "e1a9",
	"./icons8_online_store.png": "e73e",
	"./icons8_paint.png": "8e18",
	"./icons8_stage.png": "5c6e",
	"./icons8_win.png": "e43d",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo_avatar.png": "618e",
	"./logo_footer.png": "2f94",
	"./team/Caleb.jpg": "1372",
	"./team/Godday.jpeg": "384d",
	"./team/Gyan.jpg": "3bbd",
	"./team/Karla.jpeg": "fcb0",
	"./team/Mark.jpg": "74b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";